<template>
  <v-dialog persistent v-model="show" width="30%">
    <v-card class="pa-4">
      <v-row v-if="faceRecVisible">
        <v-col :cols="10" v-if="faceRecStatusTemp === 2 || faceRecStatusTemp === 3">
          <v-alert v-if="faceRecStatusTemp === 2" type="success" class="mb-0">
            %{{ faceRecValue + " " + $t("matched") }}
          </v-alert>
          <v-alert v-if="faceRecStatusTemp === 3" type="error" class="mb-0">
            {{ faceRecValue }}
          </v-alert>
        </v-col>
        <v-col
          :cols="2"
          :offset="faceRecStatusTemp !== 0 ? 0 : 10"
          class="d-flex justify-center align-center pa-3"
        >
          <v-progress-circular
            v-if="faceRecStatusTemp === 1"
            indeterminate
            color="gray"
          ></v-progress-circular>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                @click="onClickFaceRecognition"
              >
                <v-icon>mdi-face-recognition</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("face-recognition") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <div class="header-icon-wrapper">
        <img
          style="width: 100%; height: 400px; object-fit: contain"
          :src="screenshot"
        />
      </div>
      <div class="wrapper-title">
        <v-select
          label="Ekran Görüntüsü Etiketi"
          outlined
          :items="photoTags"
          v-model="selectedPhotoTag"
          item-text="name"
          item-value="code"
        ></v-select>
      </div>
      <div class="d-flex justify-end">
        <v-btn
          class="mr-2"
          outlined
          large
          color="primary"
          :disabled="cancelButtonDisabled"
          @click="onClickCancel"
        >
          İptal Et
        </v-btn>
        <v-btn
          large
          color="primary"
          :disabled="addButtonDisabled"
          @click="onClickAdd"
          >Ekle</v-btn
        >
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import PreferenceApi from "../service/PreferenceService";
import { mapGetters } from "vuex";
export default {
  name: "add-screenshot-dialog",
  mixins: [],
  props: {
    screenshot: {
      type: String,
      required: true
    },
    faceRecStatus: {
      type: Number,
      required: true
    },
    faceRecStatusTemp: {
      type: Number,
      required: true
    },
    faceRecValue: {
      type: [Number, String]
    },
    isOBAFExisting: {
      type: Boolean,
      required: true
    },
    isProcessAvailableForFaceRecognition: {
      type: Boolean,
      required: true
    },
    nfcStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedPhotoTag: "",
      photoTags: []
    };
  },
  created() {
    this.show = true;
    this.CANDIDATE_PHOTO_CODE = "OBAF";
  },
  mounted() {
    this.retrievePhotoTags();
  },
  computed: {
    addButtonDisabled: function() {
      if (this.selectedPhotoTag === this.CANDIDATE_PHOTO_CODE) {
        if (this.isOBAFExisting) {
          return true;
        }
        if (this.isProcessAvailableForFaceRecognition) {
          return this.faceRecStatusTemp !== 2;
        }
      }

      return false;
    },
    cancelButtonDisabled: function() {
      return (
        this.selectedPhotoTag === this.CANDIDATE_PHOTO_CODE &&
        this.faceRecStatusTemp === 1
      );
    },
    faceRecVisible: function() {
      return (
        this.selectedPhotoTag === this.CANDIDATE_PHOTO_CODE &&
        this.isProcessAvailableForFaceRecognition
      );
    }
  },
  methods: {
    retrievePhotoTags() {
      var phototagsMnemonic;
      console.log("====NFC STATUS ADD SCREENSHOTDIALOG====");
      console.log(this.nfcStatus);
      if(this.nfcStatus){
        phototagsMnemonic = "phototags";
      }else{
        phototagsMnemonic = "phototagsocr";
      }
      console.log(" Phototags Mnemonic  :" + phototagsMnemonic)
      console.log("====NFC STATUS ADD SCREENSHOTDIALOG====");
      PreferenceApi.getAllByMnemonic(
        this,phototagsMnemonic,
        response => {
          if (response && response.result) {
            this.photoTags = response.result;
          }
        },
        error => {
          console.log(error, "getPhotoTags error");
        }
      );
    },
    onClickCancel() {
      this.$emit("onCancel");
    },
    onClickAdd() {
      if (this.selectedPhotoTag) {
        this.$emit(
          "onAdded",
          this.screenshot,
          this.photoTags.find(
            photoTag => photoTag.value === this.selectedPhotoTag
          )
        );
      }
    },
    onClickFaceRecognition() {
      this.$emit("onClickFaceRecognition");
    }
  }
};
</script>
<style lang="scss">
$primaryColor: #3fa2f7;
.menuable__content__active {
  z-index: 10000 !important;
}
.header-icon-wrapper {
  text-align: center;

  img {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    width: 100%;
    height: 250px;
  }

  .v-icon {
    font-size: 3rem;
    padding: 25px;
    border-radius: 50%;
    border: 4px solid #3fa2f7;
  }
}

.wrapper-title {
  text-align: center;
  margin-top: 5%;
  color: $primaryColor;
}
</style>


// WEBPACK FOOTER //
// src/components/AddScreenshotDialog.vue